<template>
    <div class="page-path">
        <ol v-if="this.$route.name === 'tool'">
            <li>
                <router-link to="/">
                    <span>Thema {{ $route.params.themaid }}</span>
                </router-link>
            </li>
            <li>
                <span>Week {{ $route.params.weekid }}</span>
            </li>
            <li>
                <span>Dag {{ $route.params.dagid }}</span>
            </li>
            <li>
                <span>Les {{ $route.params.lesid }}</span>
            </li>
        </ol>
        <ol v-if="this.$route.name === 'prentenboek'">
            <li>
                <router-link to="/">
                    <span>Thema {{ $route.params.themaid }}</span>
                </router-link>
            </li>
            <li>
                <span>Prentenboek</span>
            </li>
        </ol>
    </div>
</template>

<script>
    export default {
        name: "BreadCrumb"
    };
</script>